import { useExchangeRate } from '@/hooks/useExchangeRate';
import { formatCurrency } from '@/utils/format';

export default function ExchangeRateBadge({ amount, from = 'USD', to = 'CLP' }) {
  const { rate, loading } = useExchangeRate(from, to);

  if (from === to || !rate || loading) return null;

  const converted = amount * rate;

  return (
    <span className="text-xs text-gray-400 dark:text-gray-500 font-normal ml-1">
      ≈ {formatCurrency(converted, to)}
    </span>
  );
}
